define([
	"dojo/_base/declare",
	"csi/action/Controller",
	"csi/comm",
	"csi/resolver",
	"csi/xml"
], function(declare,Controller,comm,resolver,xml) {

	return declare(Controller, {
	});
});